import { render } from "./InvitationPage.vue?vue&type=template&id=92797d5c"
import script from "./InvitationPage.vue?vue&type=script&lang=js"
export * from "./InvitationPage.vue?vue&type=script&lang=js"

import "./InvitationPage.vue?vue&type=style&index=0&id=92797d5c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__